import React from "react";
import {
  videoTutorials,
  vidAnalysis,
} from "../../devdata/constants/supportData";
import { VideoTutorial } from "../../components";
import { Button } from "../../components/ui/button";
import DhanSignupSection from "./dhanSection"
import ReferralCard from "./refferal"
import { ChevronDown } from 'lucide-react';
import FaqItem from "../../components/faq/FaqItem"
import VideoCard from "./videoCard"
const Learn = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const videos = {
    marketpulseGuides: {
      title: "How to use marketpulse.exchange for Intraday Opportunities",
      videos: [
        {
          title: "What is Marketpulse.Exchange? Complete Guide",
          videoId: "91WpIPT_l_E",
          description: "Overview of the platform, your trading edge, and what users can expect"
        },
        {
          title: "The Best Time to Enter a Trade",
          videoId: "lk_Q4Pguv4k",
          description: "Know how to utilise market pulse for the best time and best trade."
        },
        {
          title: "How to Use the Pi Scanner to Identify Winning Trades",
          videoId: "JfR1SPEhjFU",
          description: "How Pi Score works and using filtering options effectively"
        },
        // {
        //   title: "Identifying High-Probability Stocks",
        //   videoId: "AUTO_FETCH_HIGH_PROBABILITY",
        //   description: "Sector boost + High Pi Score + Early time window method"
        // },
        // {
        //   title: "Best Entry Time Explained",
        //   videoId: "AUTO_FETCH_ENTRY_TIME",
        //   description: "Why 10:15–11:15 AM is your key momentum window"
        // },
        // {
        //   title: "Using Sector Pulse for Strong Sectors",
        //   videoId: "AUTO_FETCH_SECTOR_PULSE",
        //   description: "Reading heatmaps and sector charts for momentum"
        // },
        // {
        //   title: "Combining Sector + Pi for Accuracy",
        //   videoId: "AUTO_FETCH_COMBINING",
        //   description: "Real examples of aligning sector strength with Pi Score"
        // }
      ]
    },
    algotestGuides: {
      title: "Trading via Algotest",
      videos: [
        {
          title: "Automate Your Trades with Algotest",
          videoId: "W8Yuu1KSYNQ",
          description: "Dhan/AlgoTest integration process and advantages"
        },
        {
          title: "How to Paper Trade on Marketpulse",
          videoId: "Im_iBC-7iq0",
          description: "Live demo of one-click execution from stock card"
        },
        // {
        //   title: "Automating Trades with AlgoTest",
        //   videoId: "AUTO_FETCH_AUTOMATE",
        //   description: "Remove emotions with automated Entry/Exit/SL/Targets"
        // }
      ]
    },
    dhanGuides: {
      title: "Using DHAN & Premium TradingView",
      videos: [
        {
          title: "How to Connect Your DHAN Account",
          videoId: "uumbvygPviE",
          description: "Using DHAN & Premium TradingView"
        },
        // {
        //   title: "TradingView Premium Features",
        //   videoId: "AUTO_FETCH_TRADINGVIEW",
        //   description: "Access and use TradingView premium tools"
        // }
      ]
    },
    // journalGuides: {
    //   title: "Understanding Trading Journal",
    //   videos: [
    //     {
    //       title: "Master Trading Psychology with AI",
    //       videoId: "AUTO_FETCH_TRADING_JOURNAL",
    //       description: "Using the Marketpulse AI-powered Trading Journal"
    //     }
    //   ]
    // }
  };

  const allFaqItems =
    [
      {
        question: "Who is eligible for the 3-month free access?",
        answer: "Anyone who opens a DHAN account using our referral link and registers under Four Fox Media as their AP."
      },
      {
        question: "What is the benefit of using DHAN with MarketPulse?",
        answer: "You unlock TradingView premium features, faster execution, and seamless automation with Algotest."
      },
      {
        question: "Where can I see tutorials for using the platform?",
        answer: "Right above! Start with 'How to Add Broker (DHAN)' to get connected instantly."
      }
    ]
  return (
    <div className="flex flex-col dark:bg-black p-6 h-full">
      <div className="min-h-screen bg-background text-text">
        {/* Hero Section */}
        <section className="relative min-h-[80vh] flex items-center justify-center px-4">
          <div className="absolute inset-0 z-0">
            <div className="absolute inset-0 bg-gradient-to-b from-background/80 to-background my-[240px]" />
          </div>

          <div className="container relative z-10 text-center space-y-6 max-w-4xl animate-slide-up">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
              Master the Markets. <br className="hidden md:block" />
              <span className="bg-gradient-to-r from-market-teal via-market-teal/80 to-market-teal/60 bg-clip-text text-transparent animate-glow">
                Unlock Exclusive Bonuses.
              </span>
            </h1>

            <p className="text-base md:text-lg text-subText max-w-xl mx-auto">
              Learn to use MarketPulse. Get 3 months free subscription + TradingView Premium Access by opening a DHAN Demat.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="outline"
                className="text-base md:text-lg px-5 py-3 md:px-8 md:py-5 border-white/10 hover:bg-white/5 w-full sm:w-auto"
                onClick={() => scrollToSection("tutorials_section")}
              >
                📚 Start Learning
              </Button>
              <Button
                className="text-base md:text-lg px-5 py-3 md:px-8 md:py-5 bg-market-teal hover:bg-market-teal/90 text-black font-medium w-full sm:w-auto"
                onClick={() => scrollToSection("referral_offer_section")}
              >
                🚀 Unlock Bonus
              </Button>
            </div>

            <div className="pt-2">
              <ChevronDown className="w-6 h-6 mx-auto animate-bounce opacity-50" />
            </div>
          </div>
        </section>

        {/* Main Content */}
        <div className="container py-12 md:py-20 mx-auto">

          {/* Referral Section */}
          <section id="referral_offer_section" className="mb-16">
            <ReferralCard />
          </section>
          {/* Tutorials Section */}
          <section
            id="tutorials_section"
            className="mb-16 space-y-16 px-4 sm:px-6 md:px-10 lg:px-14"
          >
            <div className="text-center mb-16 space-y-4">
              <h2 className="text-3xl md:text-4xl font-bold">Platform Tutorials</h2>
              <p className="text-gray-400">Quick videos to help you master MarketPulse</p>
            </div>

            <div className="space-y-20">
              {Object.values(videos).map((section, index) => (
                <div key={index} className="space-y-8">
                  <h3 className="text-2xl font-semibold text-market-teal">{section.title}</h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {section.videos.map((video, vIndex) => (
                      <VideoCard key={vIndex} {...video} />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </section>


          {/* DHAN Signup Section */}
          <DhanSignupSection />
          {/* FAQ Section */}
          <section id="faq_section" className="py-16  mx-auto flex flex-col items-center justify-center">

            <h2 className="text-2xl font-bold text-white mb-6 text-center">Frequently Asked Questions</h2>
            <div className="flex flex-col mt-8 w-full md:w-[737px] max-h-[660px] overflow-y-auto custom-scrollbar bg-darkMode-layer1 rounded-xl p-4 md:p-6 shadow-md">
              {allFaqItems.map((item, index) => (
                <FaqItem
                  key={index}
                  question={item.question}
                  answer={item.answer}
                  className={index > 0 ? "mt-4" : ""}
                />
              ))}
            </div>
          </section>
        </div>
      </div>

    </div>
  );
};

export default Learn;
